'use client'

import { ImageWrapper } from '@/components/image'
import { useTranslation } from '@/hooks/client/use-translation'
import SvgXmark from '@/icons/regular/Xmark'
import type { DirectoryRelease } from '@/lib/directory/aggregate-releases'

interface CompareDockItemProps {
  /** Only identity crosses in, so smaller previews (the hub prototype's shortlist) can reuse the chip. */
  item: Pick<DirectoryRelease, 'image' | 'fullName'>
  onRemove: () => void
}

// A picked family in the tray: thumbnail, name, remove.
export const CompareDockItem = ({ item, onRemove }: CompareDockItemProps) => {
  const { t } = useTranslation()
  return (
    <div className="text-navy flex h-11 items-center gap-2 rounded-full bg-white py-1 pr-1 pl-1">
      <span className="bg-navy/5 flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full">
        {item.image ? (
          <ImageWrapper
            image={item.image}
            origin="directory/dock"
            loadTime="lazy"
            sizingProps={{ sizes: '36px', minWidth: 72, maxWidth: 144, resolutionCount: 2 }}
            imgProps={{ alt: '', className: 'h-7 w-7 object-contain mix-blend-multiply' }}
          />
        ) : null}
      </span>
      <span className="max-w-[140px] truncate text-[14px] font-semibold md:max-w-[220px]">{item.fullName}</span>
      <button
        type="button"
        data-tracking="ignore"
        aria-label={t('client.compare.removeFromCompare', 'Remove {{name}} from comparison', { name: item.fullName })}
        onClick={onRemove}
        className="hover:bg-navy/10 flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full"
      >
        <SvgXmark className="h-4 w-4 fill-current" aria-hidden />
      </button>
    </div>
  )
}
